import { render, staticRenderFns } from "./RoadDeatil.vue?vue&type=template&id=2d8ac164&scoped=true&"
import script from "./RoadDeatil.vue?vue&type=script&lang=js&"
export * from "./RoadDeatil.vue?vue&type=script&lang=js&"
import style0 from "./RoadDeatil.vue?vue&type=style&index=0&id=2d8ac164&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d8ac164",
  null
  
)

export default component.exports